import { DependencyList, useMemo } from 'react';

export function useShallowMemo<T extends {}>(factory: () => T, deps: DependencyList = []): T {
  return useMemo(factory, [...(deps ?? []), ...Object.values(factory())]);
}
